import { render, staticRenderFns } from "./ambil-data-bonus.vue?vue&type=template&id=cb3aff72&"
import script from "./ambil-data-bonus.vue?vue&type=script&lang=js&"
export * from "./ambil-data-bonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports